import { render, staticRenderFns } from "./SettingsPermissions.vue?vue&type=template&id=42ba6e8c&"
import script from "./SettingsPermissions.vue?vue&type=script&lang=js&"
export * from "./SettingsPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VCardText,VList,VProgressLinear,VSubheader,VSwitch})
